import { useContext } from 'react'
import { LayerContext } from './layer-context'

/**
 * Read any provided layer from a wrapping LayerContext.
 */
export const useLayer = () => {
  const { layer } = useContext(LayerContext)
  return layer
}
